import { useState } from 'react';
/**
 * 모바일 로그인 페이지 화면 상태
 *
 * - LOGIN        : 로그인 화면
 * - FIND_ID      : 아이디 찾기
 * - FIND_PASSWORD: 비밀번호 찾기
 * - RESET        : 비밀번호 재설정
 */
export const LOGIN_VIEW = {
  LOGIN: 'LOGIN',
  FIND_ID: 'FIND_ID',
  FIND_PASSWORD: 'FIND_PASSWORD',
  RESET: 'RESET',
};

export default function useMobileLoginView() {
  const [view, setView] = useState(LOGIN_VIEW.LOGIN);

  return {
    view,

    openLogin: () => setView(LOGIN_VIEW.LOGIN),
    openFindId: () => setView(LOGIN_VIEW.FIND_ID),
    openFindPassword: () => setView(LOGIN_VIEW.FIND_PASSWORD),
    openResetPassword: () => setView(LOGIN_VIEW.RESET),
  };
}
